import { ratingTypes } from 'shared/constants/ratingTypes';

export const REFRESH_DOSSIERS = 'REFRESH_DOSSIERS';

export const GET_DOSSIER = 'GET_DOSSIER';
export const GET_DOSSIER_SUCCESS = 'GET_DOSSIER_SUCCESS';
export const GET_DOSSIER_ERROR = 'GET_DOSSIER_ERROR';

export const GET_DOSSIER_ITEMS = 'GET_DOSSIER_ITEMS';
export const GET_DOSSIER_ITEMS_SUCCESS = 'GET_DOSSIER_ITEMS_SUCCESS';
export const GET_DOSSIER_ITEMS_ERROR = 'GET_DOSSIER_ITEMS_ERROR';

export const GET_DOSSIERS = 'GET_DOSSIERS';
export const GET_DOSSIERS_SUCCESS = 'GET_DOSSIERS_SUCCESS';
export const GET_DOSSIERS_ERROR = 'GET_DOSSIERS_ERROR';

export const CREATE_DOSSIER = 'CREATE_DOSSIER';
export const CREATE_DOSSIER_SUCCESS = 'CREATE_DOSSIER_SUCCESS';
export const CREATE_DOSSIER_ERROR = 'CREATE_DOSSIER_ERROR';

export const DELETE_DOSSIER = 'DELETE_DOSSIER';
export const DELETE_DOSSIER_SUCCESS = 'DELETE_DOSSIER_SUCCESS';
export const DELETE_DOSSIER_ERROR = 'DELETE_DOSSIER_ERROR';

export const TOGGLE_DOSSIER_WATCHED_STATE = 'TOGGLE_DOSSIER_WATCHED_STATE';
export const TOGGLE_DOSSIER_WATCHED_STATE_FINISHED = 'TOGGLE_DOSSIER_WATCHED_STATE_FINISHED';

export const getDossierAction = ({ id, ratingType = ratingTypes.CREDIT_RATING }) => ({
  type: GET_DOSSIER,
  payload: {
    id,
    ratingType,
  },
});

export const getDossierItemsAction = ({
  dossierId,
  listId,
  itemType,
  ratingType,
  page,
  start,
  limit,
  sort,
  filter,
}) => ({
  type: GET_DOSSIER_ITEMS,
  payload: {
    dossierId,
    listId,
    itemType,
    ratingType,
    page,
    start,
    limit,
    sort,
    filter,
  },
});

export const refreshDossiersAction = ({ reason, ratingType = ratingTypes.CREDIT_RATING }) => ({
  type: REFRESH_DOSSIERS,
  payload: {
    reason,
    ratingType,
  },
});

export const getDossiersAction = ({ ratingType, requestParams }) => ({
  type: GET_DOSSIERS,
  payload: {
    ratingType,
    requestParams,
  },
});

export const createDossierAction = ({
  name,
  description,
  id,
  itemsData,
  organisationId,
  ratingType = ratingTypes.CREDIT_RATING,
  selectAll = false,
  sourceDossierId,
}) => ({
  type: CREATE_DOSSIER,
  payload: {
    name,
    description,
    id,
    itemsData: !selectAll ? itemsData : undefined,
    ratingType,
    organisationId,
    selectAll,
    sourceDossierId,
  },
});

export const deleteDossiersAction = ({ ids, ratingType = ratingTypes.CREDIT_RATING }) => ({
  type: DELETE_DOSSIER,
  payload: {
    ids,
    ratingType,
  },
});

export const toggleDossierWatchedStateAction = ({
  mode,
  id,
  ratingType = ratingTypes.CREDIT_RATING,
}) => ({
  type: TOGGLE_DOSSIER_WATCHED_STATE,
  payload: {
    mode,
    id,
    ratingType,
  },
});
